const actionTypes = {
    SHOW_ERROR: 'SHOW_KLARNA_ERROR',
    TOGGLE_SHIPPING: 'TOGGLE_SHIPPING',
    TOGGLE_SELECTED: 'TOGGLE_SELECTED',
    OBSERVE_MODAL: 'OBSERVE_MODAL',
    SET_READY: 'KLARNA_SET_READY'
};

module.exports = actionTypes;
